export default {
  reports: {
    gen: "Género",
    total: "Total",
    gender: "Tabla de género",
    male: "Masculino",
    female: "Femenino",
    other: "Otro",
    byCountry: "Por País",
    avgPriceFarmer: "Precio Promedio Pagado por Agricultor (Cacao)",
    avgPrice: "Precio Promedio",
    selectYear: "seleccionar año",
    farmerName: "Nombre del granjero",
    farmerProdChart: "Gráfico de producción del granjero",
    production: "Producción",
    byProduction: "Por producción",
    byName: "Por nombre",
    descending: "Descendiente",
    ascending: "Ascendiente",
    buyingStationProdChart: "Gráfico de producción de la central de compra",
    buyingStation: "Central de Compra",
    buyingStationName: "Nombre de la central de compra",
    dryMilling: "Molienda en seco",
    dryMillingName: "Nombre de la molienda en seco",
    dryMillingProdChart: "Gráfico de producción de la molienda en seco",
    view: "Vista",
    date: "Fecha",
    reports: "Informes",
    today: "Hoy",
    week: "Semana",
    month: "Mes",
    year: "Año",
    all: "Todo",
    selectCrop: "Seleccionar Cultivo",
    selectRegion: "Seleccionar Región",
    downloadPdfReport: "Descargar Informe en PDF",
    export: "Exportar",
    search: "Buscar",
    yield: "Rendimiento",
    pests: {
      pestReport: "Informe de Plagas",
      filterByCrops: "Filtrar por Cultivos",
      pestStatistics: "Estadísticas de Plagas",
      regions: "Regiones",
      occurrences: "Ocurrencias",
      pestChart: "Gráfico de Plagas",
      totalArea: "Área Total",
      pestName: "Nombre de la Plaga",
      region: "Región",
      crop: "Cultivos",
      listByLand: "Lista por Terreno",
    },
    regions: {
      regionalReport: "Informe Regional",
      listByFarm: "Listar por Finca",
      listByFarmers: "Listar por Agricultores",
      listByYield: "Listar por Rendimiento",
      regionalStatistics: "Estadísticas Regionales",
      countries: "Países",
      states: "Estados/Provincias",
      city: "Ciudad/Pueblo/Villa",
      farmsIn: "Fincas en",
      regionalChart: "Gráfico Regional",
      farms: "Fincas",
      regionName: "Nombre de la Región",
      farmers: "Agricultores",
      yield: "Rendimiento/Acre",
    },
    dashboard: {
      topCharts: "Principales Gráficos",
      regions: "Regiones",
      noOfFarms: "Núm. de Fincas/Región",
      provinces: "Provincias Estados",
      landArea: "Área de Tierra",
      avgFarmerLand: "Prom. de Tierra por Agricultor",
      viewAll: "Ver Todo",
      crops: "Cultivos",
      plantedAreaCrop: "Área Plantada/Cultivo",
      plantedArea: "Área Plantada",
      avgYieldCrop: "Rendimiento Promedio/Cultivo",
      averageYield: "Rendimiento Promedio",
      yieldChart: "Gráfico de Rendimiento",
      selectFarm: "Seleccionar Finca",
      soilQuality: "Calidad del Suelo",
      pests: "Plagas",
      occurrences: "Ocurrencias",
      equipments: "Equipos",
      goalAchievedChart: "Gráfico de Metas Alcanzadas",
      soilValues: "Valores del Suelo",
      soil: "Suelo",
      showReport: "Mostrar Informes en el Panel de Control",
      selectAll: "Seleccionar Todo",
    },
    weight: "Peso",
    quality: "Calidad",
    price: "Precio",
  },
}